

export const paginationIconStyles = {
  fontSize: '12px'
};

export const paginationIconLinkStyles = {
  paddingTop: '5px',
  paddingBottom: '4px',
  paddingLeft: '9px',
  paddingRight: '9px',
  cursor: 'pointer'
};

export const paginationItemStyles = (props) => {
  let background = (props.active ? '#319bd5' : '#FFF');
  let color = (props.active ? '#FFF' : 'black');
  let border= (props.active ? 'none' : '1px solid #dee2e6');
  let paddingBottom = (props.active ? 'default' : '7px');
  return {
    fontSize: '12px',
    background,
    color,
    border,
    paddingBottom,
    zIndex: 0
  }
};
